// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_ReserveInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Reserve request body.
 *
 * Required fields:
 *   franquia_id  (int)    — billing franchise (payer-validated against user permissions)
 *   request_id   (string) — idempotency key
 *   model        (string) — AI model name (app-api derives the flat-cap micro estimate)
 *
 * Note: est_micro is NOT supplied by the caller — app-api derives it via priceUsage
 * using the flat-cap constants in credits.php. This keeps all pricing math server-side.
 */
import { registerContract } from './validate'

export interface AiCredits_ReserveInput {
franquia_id: number
request_id: string
model: string
}

registerContract('AiCredits_ReserveInput', {
  franquia_id: { type: 'number',  required: true },
  request_id:  { type: 'string',  required: true },
  model:       { type: 'string',  required: true },
})
